import { render, staticRenderFns } from "./GModal.vue?vue&type=template&id=236cc370&scoped=true"
import script from "./GModal.vue?vue&type=script&lang=js"
export * from "./GModal.vue?vue&type=script&lang=js"
import style0 from "./GModal.vue?vue&type=style&index=0&id=236cc370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236cc370",
  null
  
)

export default component.exports